import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container is-flex is-flex-direction-column" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("button", {
  class: "button is-primary is-align-self-flex-start mt-3",
  disabled: ""
}, " Nova Licença ", -1)

import HeroHeader from '@/components/HeroHeader.vue';
  import TabelaLicencas from '@/components/TabelaLicencas.vue';
  import ILicenca from '@/interfaces/ILicenca';
  import { useStore } from '@/store';
  import axios from 'axios';
  import { Ref, onBeforeMount, ref } from 'vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'LicencasView',
  setup(__props) {

  const store = useStore();
  const licencas: Ref<ILicenca[]> = ref([]);

  onBeforeMount(() => {
    getLicencas();
  });

  function getLicencas(): void {
    store.commit('showLoading');
    axios
      .get('https://cert.abaccusapi.com.br/v2/painel')
      .then(resp => {
        montaLicencas(resp.data);
        store.commit('hideLoading');
      })
      .catch(err => console.error(err));
  }
  function montaLicencas(data: ILicenca[]): void {
    data
    .filter(licenca => licenca.revogado === 'N' && licenca.exibir === 'S')
    .forEach(licenca => {
      licenca.qtdObjetos = Object.entries(licenca.objetos).length,
      licencas.value.push(licenca);
    });
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(HeroHeader, {
      title: "Licenças",
      subtitle: "Gerencie as licenças do Abaccus Decision"
    }),
    _createElementVNode("div", _hoisted_1, [
      (licencas.value.length)
        ? (_openBlock(), _createBlock(TabelaLicencas, {
            key: 0,
            licencas: licencas.value
          }, null, 8, ["licencas"]))
        : _createCommentVNode("", true),
      _hoisted_2
    ])
  ], 64))
}
}

})